import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FlaskConical, Truck, Microscope, FileCheck2, ArrowRight } from "lucide-react";
import { Section, SectionHeading, Eyebrow } from "@/components/Section";
import { STEPS } from "@/data/site";

const ICONS = [FlaskConical, Truck, Microscope, FileCheck2];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <section className="bg-ocean">
        <div className="mx-auto max-w-7xl px-6 py-20 text-center md:px-10 md:py-24">
          <Eyebrow>Simple, transparent process</Eyebrow>
          <h1 className="mx-auto mt-5 max-w-3xl text-4xl font-bold tracking-tight text-white sm:text-5xl">How It Works</h1>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-300">Four clear steps from order to lab-verified results — no guesswork.</p>
        </div>
      </section>

      <Section>
        <div className="space-y-6">
          {STEPS.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div key={s.n} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }}
                className="group flex flex-col gap-6 rounded-2xl border border-border bg-white p-8 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_45px_rgba(47,76,120,0.1)] md:flex-row md:items-center md:p-10">
                <div className="flex items-center gap-5 md:w-64 md:shrink-0">
                  <span className="font-heading text-5xl font-bold text-teal/30">{s.n}</span>
                  <span className="grid h-14 w-14 place-items-center rounded-2xl bg-accent transition-colors duration-300 group-hover:bg-navy"><Icon className="h-7 w-7 text-teal-dark transition-colors duration-300 group-hover:text-lime" /></span>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-ocean">{s.title}</h3>
                  <p className="mt-2 text-slate-600">{s.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
        <div className="mt-12 rounded-2xl border border-teal/30 bg-accent/50 p-8 text-center">
          <h3 className="text-xl font-semibold text-ocean">Money-back guarantee</h3>
          <p className="mx-auto mt-2 max-w-xl text-slate-600">If your results are not delivered within 14 days of us receiving your sample, you get a full refund.</p>
        </div>
        <div className="mt-12 text-center">
          <Link to="/pricing" className="inline-flex items-center gap-2 rounded-full bg-ocean px-8 py-3.5 text-base font-semibold text-white transition-colors hover:bg-ocean-light">
            Choose Your Test <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </Section>
    </div>
  );
}
